__turbopack_context__.v({
  "background": "_90u7qq_background",
  "content": "_90u7qq_content",
  "inner": "_90u7qq_inner",
  "root": "_90u7qq_root",
  "strike": "_90u7qq_strike",
  "strikeAnimation": "_90u7qq_strikeAnimation",
  "strikeGlow": "_90u7qq_strikeGlow",
});
